const _SR_DEFAULTS = {
  continuous: false,
  interimResults: false,
  maxAlternatives: 3
}

export const SPEECH = {
  start(callbacks = {}) {
    return new Promise(function(resolve, reject) {
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition
      if (!SpeechRecognition) return resolve(false)

      const instance = new SpeechRecognition()

      instance.continuous = _SR_DEFAULTS.continuous
      instance.interimResults = _SR_DEFAULTS.interimResults
      instance.maxAlternatives = _SR_DEFAULTS.maxAlternatives

      instance.onstart = function() {
        console.log('onstart')
        callbacks.onstart && callbacks.onstart()
      } // TODO change color or so for current input or icon
      instance.onend = function() {
        console.log('onend')
        callbacks.onend && callbacks.onend()
        instance.stop()
      } // TODO restore input state
      instance.onspeechstart = function() {
        console.log('onspeechstart')
      }
      instance.onspeechend = function() {
        console.log('onspeechend')
      }

      instance.onresult = function(event) {
        const { results, resultIndex } = event
        console.log(
          'resultIndex, results.length, results',
          resultIndex,
          results.length,
          results
        )
      }

      instance.onerror = function(event) {
        if (/^(not-allowed)$/.test(event.error)) {
          console.log('Not-allowed by user')
        } else if (/^(network)$/.test(event.error)) {
          console.log('Network not reachable!', event)
          // _fn.end.call(voice);
        } else if (/^(no-speech)$/.test(event.error)) {
          // _fn.end.call(voice);
        } else {
          console.log(
            '%cError in Voice Recognition! => %s',
            'color:red;',
            event.error,
            event
          )
        }

        callbacks.onerror && callbacks.onerror(event.error)
        reject(event.error)
      }

      resolve(instance)
    })
  }
}
